<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between pb-3>
      <h2>Mass add</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{ err }}
    </v-alert>
    <div>
      <v-layout row wrap align-start justify-space-between>
        <v-flex xs6 px-2>
          <v-select
            label="Add type"
            :items="types"
            item-text="name"
            item-value="value"
            v-model="type"
            hide-details
          />
        </v-flex>
        <v-flex xs7 px-2>
          <transition name="fade">
            <v-combobox
              v-if="type === 'taxCategory'"
              :label="label"
              :items="taxCategories"
              v-model="taxCategory"
              @input.native="e => taxCategory = e.target.value"
            >
            </v-combobox>
          </transition>
          <transition name="fade">
            <v-select
              v-if="type === 'vatRate'"
              :items="vatItems"
              class="pt-2"
              :disabled="!this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0 ? true : false"
              v-model="vatRate"/>
          </transition>
        </v-flex>
      </v-layout>
      <v-flex xs12 py-4 px-2>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'views'">
            <v-layout wrap row align-center>
              <v-checkbox
                v-for="(view, index) in viewsClone"
                :key="index"
                color="primary"
                v-model="view.selected"
                @change="$forceUpdate()"
                :label="view.name[language]">
              </v-checkbox>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'printerCategories'">
            <v-layout wrap row align-center>
              <v-checkbox
                v-for="(printer, index) in catalogPrinters"
                :key="index"
                color="primary"
                v-model="printer.selected"
                @change="$forceUpdate()"
                :label="printer.name">
              </v-checkbox>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'settings'">
            <v-layout wrap row align-center>
              <v-checkbox
                v-for="(setting, index) in settings"
                :key="index"
                color="primary"
                v-model="setting.selected"
                @change="$forceUpdate()"
                :label="setting.name">
              </v-checkbox>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'sizes'">
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="size.en"
                  label="EN Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="size.de"
                  label="DE Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="size.zh"
                  label="ZH Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="size.price"
                  label="Price"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-checkbox
                  color="primary"
                  v-model="size.isDefault"
                  @change="$forceUpdate()"
                  label="Set as Default">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'variants'">
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="variant.en"
                  label="EN Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="variant.de"
                  label="DE Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="variant.zh"
                  label="ZH Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="variant.price"
                  label="Price"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-checkbox
                  color="primary"
                  v-model="variant.isDefault"
                  @change="$forceUpdate()"
                  label="Set as Default">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'options'">
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="option.en"
                  label="EN Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="option.de"
                  label="DE Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="option.zh"
                  label="ZH Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="option.price"
                  label="Price"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-checkbox
                  color="primary"
                  v-model="option.isDefault"
                  @change="$forceUpdate()"
                  label="Set as Default">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'styles'">
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="style.en"
                  label="EN Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="style.de"
                  label="DE Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
              <v-flex xs4 px-1>
                <v-text-field
                  v-model="style.zh"
                  label="ZH Name"
                  @change="$forceUpdate()">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row align-center>
              <v-flex xs4 px-1>
                <v-checkbox
                  color="primary"
                  v-model="style.isDefault"
                  @change="$forceUpdate()"
                  label="Set as Default">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div v-if="type === 'items'">
            <v-layout wrap row align-center>
              <v-flex xs12 px-1>
                <v-autocomplete
                  v-model="selectedItemId"
                  :items="catalogToShow"
                  :search-input="search"
                  hide-no-data
                  hide-selected
                  item-text="nameToShow"
                  item-value="itemId"
                  :label="$lang.labels.parentCopyFrom"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </div>
        </transition>
      </v-flex>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitMassAdd()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MassAddModal",
  props: ['data', 'taxCategories', 'selectedCompanyInfo', 'views', 'catalog'],
  data() {
    return {
      language: this.$cookie.get('lang') || 'en',
      languages: [
        {
          text: "English",
          value: "en"
        },
        {
          text: "German",
          value: "de"
        },
        {
          text: "Chinese",
          value: "zh"
        }
      ],
      size: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false,
      },
      variant: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false,
      },
      style: {
        en: '',
        de: '',
        zh: '',
        isDefault: false,
      },
      option: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false,
      },
      types: [
        {name: this.$lang.labels.taxCategory, value: 'taxCategory'},
        {name: this.$lang.labels.VAT, value: 'vatRate'},
        {name: this.$lang.labels.views, value: 'views'},
        {name: this.$lang.labels.printerCategories, value: 'printerCategories'},
        {name: this.$lang.labels.settings, value: 'settings'},
        {name: this.$lang.labels.size, value: 'sizes'},
        {name: this.$lang.labels.variant, value: 'variants'},
        {name: this.$lang.labels.style, value: 'styles'},
        {name: this.$lang.labels.option, value: 'options'},
        {name: this.$lang.labels.parentCopy, value: 'items'},
      ],
      taxCategory: 'standard',
      type: null,
      vatRate: null,
      viewsClone: [],
      err: '',
      printerCategories: [
        'LABEL',
        'KITCHEN1',
        'KITCHEN2',
        'KITCHEN3',
        'KITCHEN4',
        'KITCHEN5',
        'BAR1',
        'BAR2',
        'BAR3',
        'BAR4',
        'BAR5',
        'SALAD1',
        'SALAD2',
        'SALAD3',
        'SALAD4',
        'SALAD5',
      ],
      catalogPrinters: [],
      settings: [
        {name: 'Label Print', value: 'labelPrint', selected: false},
        {name: 'Ask details', value: 'askDetails', selected: false},
        {name: 'VAT print', value: 'vatPrint', selected: false},
        {name: 'No discount', value: 'noDiscount', selected: false},
        {name: 'Adds Galaxy Card balance', value: 'galaxyCardBalance', selected: false},
      ],
      selectedItemId: null,
      search: null,
      catalogToShow: [],
    }
  },
  computed: {
    label() {
      return this.types.filter(type => type.value === this.type)[0].name || 'Value'
    },
    vatItems() {
      return this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 ?
        [{
          text: 'Not selected',
          value: null
        }, ...this.selectedCompanyInfo.vatRates.map(vatRateItem => ({
          text: `${vatRateItem}`,
          value: `${vatRateItem}`
        }))] :
        [{value: 'null', text: 'null'}];
    },
  },
  watch: {
    err(val) {
      if (val !== '') {
        setTimeout(() => {
          this.err = '';
        }, 5000);
      }
    },
  },
  created() {
    const viewClone = JSON.parse(JSON.stringify(this.views));
    this.viewsClone = viewClone.map(x => {
      x.selected = false;
      return x;
    });
    this.catalogPrinters = this.printerCategories.map((current) => {
      const printer = {
        name: current,
      };
      printer.selected = false;
      return printer;
    });
    this.flattenCatalog();
  },
  methods: {
    flattenCatalog() {
      const newCatalog = [];
      let howDeep = 0;
      const addItems = (items) => {
        items.forEach((item, index) => {
          let prefix = '';
          if (howDeep !== 0) {
            for (let i = 0; i < howDeep; i += 1) {
              prefix += '  --'
            }
          }
          newCatalog.push({...item, nameToShow: `${prefix}${item.name[this.language]}`});
          if (item.items && item.items.length > 0 ) {
            howDeep += 1;
            addItems(item.items);
          }
          if (index === items.length -1) {
            howDeep -= 1;
          }
      });
      };
      addItems(this.catalog);
      this.catalogToShow = newCatalog;
    },
    submitMassAdd() {
      if (!this.type) {
        this.err = 'You must select Add type!';
        return
      }
      if (this.type === 'taxCategory' && this.taxCategory === '') {
        this.err = 'Tax category cannot be empty!';
        return;
      }
      if (this.type === 'vatRate' && this.vatRate === '') {
        this.err = 'VAT rate cannot be empty!';
        return;
      }
      if (this.type === 'sizes' && this.size[this.selectedCompanyInfo.defaultLanguage] === '') {
        this.err = 'Size in default language cannot be empty!';
        return;
      }
      if (this.type === 'sizes' && this.size.price === '') {
        this.err = 'Size needs to have price!';
        return;
      }
      if (this.type === 'items' && !this.selectedItemId) {
        this.err = 'You need to select item to copy children!';
        return;
      }
      let submitObj = {};
      submitObj.type = this.type;
      submitObj.item = this.data;
      if (this.type === 'taxCategory') {
        submitObj.value = this.taxCategory;
      }
      if (this.type === 'vatRate') {
        submitObj.value = this.vatRate;
      }
      if (this.type === 'views') {
        submitObj.value = this.viewsClone.map(x => {
          if (x.selected) return x.viewId;
        });
        submitObj.value = submitObj.value.filter(function (el) {
          return el != null;
        });
      }
      if (this.type === 'printerCategories') {
        submitObj.value = this.catalogPrinters.map(x => {
          if (x.selected) return x.name;
        });
        submitObj.value = submitObj.value.filter(function (el) {
          return el != null;
        });
      }
      if (this.type === 'settings') {
        submitObj.value = this.settings.map(x => {
          if (x.selected) return x.value;
        });
      }
      if (this.type === 'sizes') {
        submitObj.value = this.size;
      }
      if (this.type === 'variants') {
        submitObj.value = this.variant;
      }
      if (this.type === 'styles') {
        submitObj.value = this.style;
      }
      if (this.type === 'options') {
        submitObj.value = this.option;
      }
      if (this.type === 'items') {
        submitObj.value = this.selectedItemId;
      }
      this.$emit('submit', submitObj);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MassAddModal.vue?55da414f